import { Check, Close, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { RegistrationCivilUnionFormVM } from 'mutation/view-models/registration-civil-union';
import { CivilUnionVM } from 'mutation/view-models/civil-union';
import CivilUnionForm from 'mutation/components/shared/form-civil-union/resident';
import { checkPersonRegistrationCivilUnion } from 'mutation/utils/transformer-registration-civil-union';

interface CivilUnionProps {
  disabled?: boolean;
}

const CivilUnionComponent = ({ disabled }: CivilUnionProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<RegistrationCivilUnionFormVM>();

  const onFieldCivilUnionChange = useEventCallback(
    (key: keyof CivilUnionVM, value: CivilUnionVM[keyof CivilUnionVM]) => {
      formContext.setFieldValue('civilUnion', {
        ...(formContext.values.civilUnion || {}),
        [key]: value,
      });
    }
  );

  const onFieldCivilUnionChangeValues = useEventCallback((value: CivilUnionVM) => {
    formContext.setFieldValue('civilUnion', {
      ...(formContext.values.civilUnion || {}),
      ...value,
    });
  });

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-union-civil-content"
          id="panel-union-civil-header"
          expandIcon={<ExpandMore />}
        >
          {formContext.errors.civilUnion ? <Close color="error" /> : <Check color="success" />}
          <Typography>Unione civile</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CivilUnionForm
            values={formContext.values.civilUnion}
            onChange={onFieldCivilUnionChange}
            onChangeValues={onFieldCivilUnionChangeValues}
            errors={formContext.errors.civilUnion as FormikErrors<CivilUnionVM>}
            touched={formContext.touched.civilUnion as unknown as FormikTouched<CivilUnionVM>}
            checkPerson={(person) => {
              return checkPersonRegistrationCivilUnion(person.statoCivile?.statoCivile);
            }}
            disabled={disabled}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

CivilUnionComponent.displayName = 'Accordion Civil Union component';

const CivilUnion = memo(CivilUnionComponent);

export default CivilUnion;
